module.exports = __webpack_public_path__ + "img/v-icon.e75b9b28.png";